"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SurveyResultsCountCard = void 0;
const adaptivecards_1 = require("adaptivecards");
const CardHelper_1 = require("../../_shared/utils/CardHelper");
const actions_1 = require("../actions");
const SurveyResultsCountCard = (survey) => {
    const card = CardHelper_1.CardHelper.newCard();
    card.addItem(CardHelper_1.CardHelper.create(adaptivecards_1.TextBlock, {
        text: `${survey.responseCount} completion${survey.responseCount === 1 ? "" : "s"}.`,
        wrap: true,
    }));
    card.addAction((0, actions_1.ViewSurveyResultsAction)(survey.id));
    return card;
};
exports.SurveyResultsCountCard = SurveyResultsCountCard;
//# sourceMappingURL=SurveyResultsCountCard.js.map